import React from 'react';

export const SnoozeIcon = (props) => {
  const { theme } = props;

  let colour = 'rgba(74, 88, 102, 0.6)';

  if (theme === 'dark') {
    colour = 'rgba(185, 193, 200, 0.6)';
  }

  return (
    <svg width="10" height="10.5" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.53194 6.44581H7.46244L4.73184 9.63885C4.32813 10.116 4.66578 10.85 5.28971 10.85H8.46806C8.87178 10.85 9.20209 10.5197 9.20209 10.116C9.20209 9.71225 8.87178 9.38194 8.46806 9.38194H6.53756L9.26816 6.1889C9.67187 5.71178 9.33422 4.97775 8.71029 4.97775H5.53194C5.12822 4.97775 4.79791 5.30806 4.79791 5.71178C4.79791 6.1155 5.12822 6.44581 5.53194 6.44581ZM13.8265 3.08395C13.5696 3.39224 13.1071 3.43629 12.7915 3.17937L10.538 1.30026C10.2297 1.036 10.1857 0.573565 10.4499 0.265272C10.7069 -0.0430213 11.1693 -0.0870631 11.4849 0.169848L13.7384 2.04897C14.0467 2.31322 14.0907 2.77566 13.8265 3.08395ZM0.173512 3.08395C0.430423 3.39958 0.892862 3.43629 1.20116 3.17937L3.45463 1.30026C3.77026 1.036 3.81431 0.573565 3.55005 0.265272C3.29314 -0.0503616 2.8307 -0.0870631 2.52241 0.169848L0.261596 2.04897C-0.046697 2.31322 -0.0907388 2.77566 0.173512 3.08395ZM7 2.77566C9.83336 2.77566 12.1382 5.08051 12.1382 7.91387C12.1382 10.7472 9.83336 13.0521 7 13.0521C4.16664 13.0521 1.86178 10.7472 1.86178 7.91387C1.86178 5.08051 4.16664 2.77566 7 2.77566ZM7 1.3076C3.35187 1.3076 0.393722 4.26574 0.393722 7.91387C0.393722 11.562 3.35187 14.5202 7 14.5202C10.6481 14.5202 13.6063 11.562 13.6063 7.91387C13.6063 4.26574 10.6481 1.3076 7 1.3076Z"
        fill={colour}
      />
    </svg>
  );
};
